<template>
  <div class="form-field-container">
    <label v-if="showLabel" :for="id" class="form-label">{{ label }}</label>
    <div v-if="showRequired" class="required-mark-container">
      <span v-if="required" class="required-mark">必須</span>
    </div>
    <div class="select-container">
      <input 
        :id="id" 
        :name="id" 
        :class="selectClass" 
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        :disabled="disabled"
        :placeholder="placeholder"
        list="datalist-options"
        autocomplete="off"
      />
      <datalist id="datalist-options">
        <option v-for="option in options" :key="option.value" :value="option.value">
          {{ option.label }}
        </option>
      </datalist>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormSelectTextField',
  props: {
    label: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    showRequired: {
      type: Boolean,
      default: true
    },
    selectClass: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '選択してください'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.form-field-container {
  display: flex;
  align-items: center;
  background-color: #FFF;
  padding: 10px 30px;
  margin: 5px;
  border-radius: 4px;
}

.form-label {
  min-width: 180px;
  font-weight: 700;
  flex: 0 0 180px;
}

.required-mark-container {
  width: 40px;
  margin-right: 10px;
  flex-shrink: 0;
}

.required-mark {
  background-color: #ff0000;
  color: white;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 12px;
  width: 100%;
  text-align: center;
  display: inline-block;
}

.select-container {
  width: 200px; /* Fixed width as requested */
  min-width: 200px; /* Ensure minimum width for the select field */
}

input {
  width: 100%;
  padding: 8px;
  border: 2px solid #195983;
  border-radius: 4px;
  box-sizing: border-box;
  background-color: white;
}
</style>
